import {SettlementVendorByDocumentMovementDto} from "../../../dtos/transactions/SettlementVendorByDocumentMovementDto";
import {format} from "date-fns";
import {DataGrid} from "devextreme-react";
import {Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel} from "devextreme-react/data-grid";
import {MovementTypeColumn} from "./MovementTypeColumn";
import React, {useTransition} from "react";
import {useTranslation} from "react-i18next";
import {ISettlementVendorTransactionRecordDto} from "../../../dtos/transactions/ISettlementVendorTransactionRecordDto";

interface IProps {
    items: ISettlementVendorTransactionRecordDto[];
}

export const SettlementVendorMovementTable = ({items}: IProps) => {
    const pageSizes = [10, 25, 50, 100];
    const {t} = useTranslation();
    
    console.log("SettlementVendorMovementTable", items);

    return (
        <>
            <div className={"overflow-auto"}>
                <DataGrid
                    dataSource={items}
                    sorting={{mode: "multiple"}}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    allowColumnResizing={true}
                    selection={{mode: "single"}}
                    loadPanel={{enabled: true, showIndicator: true, showPane: false}}
                >
                    <ColumnChooser enabled={true}/>
                    <GroupPanel visible={true}/>
                    <SearchPanel visible={true} highlightCaseSensitive={true}/>
                    <Grouping autoExpandAll={false}/>

                    <Column dataField="tableMovementType"
                            dataType="string"
                            caption={"Movement Type"}
                            width={100}
                            cellRender={(column: any) => {
                                return <MovementTypeColumn column={column}/>
                            }}/>

                    <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"}
                            sortOrder={"asc"}
                            sortIndex={1}/>
                    <Column width={150} dataField={"companyId"} dataType="string"/>
                    <Column width={150} dataField={"companyName"} dataType="string"/>

                    <Column width={150} dataField={"vendorId"} dataType="string"/>
                    <Column width={150} dataField={"vendorName"} dataType="string"/>
                    
                    <Column width={150} dataField={"contractId"} dataType="string"/>
                    <Column width={150} dataField={"contractName"} dataType="string"/>

                    <Column width={150} dataField={"vendorSettlementAnalyticId"} dataType="string"/>
                    <Column width={150} dataField={"vendorSettlementAnalyticName"} dataType="string"/>
                    
                    <Column width={150} dataField={"arApDocumentId"} dataType="string"/>
                    <Column width={150} dataField={"arApDocumentDocumentPresentationName"} dataType="string"/>
                    
                    <Column width={150} dataField={"currencyName"} dataType="string"/>
                    <Column width={150} dataField={"currencyId"} dataType="string"/>
                    
                    <Column width={150} dataField={"amountLocal"} dataType="number"/>
                    <Column width={150} dataField={"amount"} dataType="number"/>
                    {/*<Column width={150} dataField={"paid"} dataType="number"/>*/}
                    {/*<Column width={150} dataField={"toPayByVendor"} dataType="number"/>*/}
                    {/*<Column width={150} dataField={"toReceiveFromVendor"} dataType="number"/>*/}
                    
                    {/*<Column width={150} dataField={t("businessTransaction")} dataType="number"/>*/}

                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true}/>
                    <Paging defaultPageSize={10}/>
                </DataGrid>
            </div>
        </>
    )
}
